<template>
  <div>
    <div class="header">
      <p></p>
      <div class="zhong">
        <el-button type="primary" class="button1">导出报表</el-button>
      </div>
    </div>
    <!-- <div class="findWrap"> -->
      <div class="left com">
        <el-form
          :inline="true"
          :model="formInline"
          ref="formInline"
          class="demo-form-inline"
          style="text-align: left;"
          size="small"
        >
          <el-form-item label="订单编号">
            <el-input v-model="formInline.orderId" placeholder="请输入订单编号"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="formInline.type" placeholder="请选择账单类型">
              <el-option label="全部" value="0"></el-option>
              <el-option label="收入" value="2"></el-option>
              <el-option label="支出" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="efi" label="支付渠道:">
            <el-select v-model="formInline.payType" placeholder="请选支付渠道">
             <el-option label="全部" value="0"></el-option>
          <el-option label="微信" value="2"></el-option>
          <el-option label="支付宝" value="3"></el-option>
          <el-option label="润泽钱包" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围" class="dateWarp">
            <el-date-picker :clearable="false" 
              style="width: 100%;"
              :unlink-panels="unlik"
              v-model="formInline.range"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    <!-- </div> -->
    <div class="btn">
      <el-button @click="find" type="primary" style="height: 35px;line-height: 10px;">查询</el-button>
      <el-button @click="resetForm" type="info" style="height: 35px;line-height: 10px;">重置</el-button>
    </div>
    <total :data="totalData"></total>
    <el-table :data="list" stripe :header-cell-style="cell" style="width: 100%;">
      <el-table-column align="center" prop="refOrderId" label="订单编号"></el-table-column>
      <el-table-column align="center" prop="put" label="类型"></el-table-column>
      <el-table-column align="center" prop="channel" :formatter="channelFormat" label="支付渠道"></el-table-column>
      <el-table-column align="center" :formatter="tofixed" prop="amount" label="金额（元）"></el-table-column>
      <el-table-column align="center" prop="subject" label="交易方"></el-table-column>
      <el-table-column align="center" prop="createTime" label="发表时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div 
            class="refundBtn"
            v-show="scope.row.type == 5"
            @click="toViewDetail(scope.row.refOrderId)"
          >退款详情</div>
        </template>  
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <div class="pageWrap">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="count"
        @current-change="clickPage"
      ></el-pagination>
      <!-- 退款记录弹框 -->
    <el-dialog 
      title="退款记录" 
      width="458px" 
      :visible.sync="refundRecord">
      <el-form 
        label-width="50" 
        class="record"
        ref="form"
        :inline="true"
      >
        <div class="dataList">
          <div class="refundDate">
            <span class="refundTime">订单金额 ：￥{{refundRecordData.orderAmount?refundRecordData.orderAmount:0}}</span>
            <span class="refundTime">退款金额 ：￥{{refundRecordData.refundAmount?refundRecordData.refundAmount:0}}</span>
          </div> 
          <div class="refundDate" v-show="refundRecordData.channel == 3">
            <span class="refundTime" >退款手续费 ：{{refundRecordData.fee}}</span>
          </div>      
          <div class="refundDate">
            <span class="refundTime">退款渠道 ：{{refundRecordData.channel == 1?'园区钱包':refundRecordData.channel == 2?'微信支付':'支付宝支付'}}</span>
             <span class="refundTime">退款状态 ：{{refundRecordData.status == 1?'退款成功':'待入账'}}</span>
          </div>
          <div class="refundMothod">
            <span class="proson">用户名称 ：{{refundRecordData.realname?refundRecordData.realname:'无'}}</span>
            <span class="proson">操作人 ：{{refundRecordData.handlerName?refundRecordData.handlerName:'无'}}</span>
          </div>
          <div class="refundDate">
            <span class="refundTime">退款时间 ：{{refundRecordData.createTime?refundRecordData.createTime:'无'}}</span>
            <span class="refundTime">到账时间 ：{{refundRecordData.updateTime?refundRecordData.updateTime:'无'}}</span>
          </div>
          <div class="orderId">
            <span class="text">退款编号 ：{{refundRecordData.refundOrderId?refundRecordData.refundOrderId:'无'}}</span>
          </div>   
          <div class="oldOrderId">
            <span class="text">
              <span class="number">原订单编号 ：<span id="target">{{refundRecordData.sourceOrderId}}</span> </span> 
              <span class="font" @click="copyOrderId" data-clipboard-target="#target">复制</span>
              </span>
          </div>  
          <div class="refundNote">
            <span class="refundNoteName">退款备注 ：</span>
            <span class="refundNoteText">{{refundRecordData.desc?refundRecordData.desc:'无'}}</span>
          </div>
        </div>
      </el-form>
		</el-dialog>
    </div>
  </div>
</template>

<script>
import { refundDetail} from "@/api/finance";
import { toFixed } from "@/utils";
import { getDetail } from "@/api/merchant/merDetail";
import Total from "@/components/Total.vue";
import Clipboard from 'clipboard'; 
export default {
  name: "",
  props: [""],
  components: { Total },
  data() {
    return {
      mchId: 0, //商户id
      currentPage: 1,
      count: 0,
      pageSize: 10,
      unlik: true,
      totalStr: "", //用于显示总值
      totalData: {},
      formInline: {
        range: [],
        orderId: "",
        type: "",
        payType:'0',
        start: "",
        end: ""
      },
      data: [],
      count: 0,
      dateTimes : '',
      pickerOptions: {
        shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
      refundRecordData:{},
      refundRecord:false
    };
  },
  created() {
    this.mchId = this.$route.query.id;
    this._getDetailList();
  },
  computed: {
    list() {
      let list = this.data;
      console.log(list);
      let len = this.data.length;
      for (let i = 0; i < len; i++) {
        // 4 提现退款 3 支出
        list[i]["put"] =
          list[i].type == 1
            ? "收入"
            : list[i].type == 3
            ? "支出"
            : list[i].type == 4
            ? "提现驳回"
            : list[i].type == 5
            ? "退款"
            : ""
      }
      return list;
    }
  },
  methods: {
    //转化小数
    tofixed(row, column, cellValue) {
      return toFixed(cellValue);
    },
    find() {
      this.data = [];
      this.currentPage = 1;
      this._getDetailList();
    },
    clickPage(currentPage) {
      this.currentPage = currentPage;
      this._getDetailList();
    },
    resetForm() {
      this.formInline = {
        range: [],
        orderId: "",
        type: "",
        start: "",
        end: ""
      };
      this.currentPage = 1;
      this._getDetailList();
      // console.log(this.$refs.formInline.resetFields)
      // this.$refs.formInline.resetFields();
    },
    // 详情列表
    _getDetailList() {
      const data = {
        companyId: Number(this.mchId),
        end: this.formInline.range[1],
        orderId: !this.formInline.orderId ? 0 : Number(this.formInline.orderId),
        page: this.currentPage,
        rows: this.pageSize,
        start: this.formInline.range[0],
        type: this.formInline.type == "" ? 0 : Number(this.formInline.type),
        payType:this.formInline.payType == "" ? 0 : Number(this.formInline.payType),
      };
      getDetail(data)
        .then(res => {
          // this.totalStr = `选中时间内总收入：${res.data.totalInconme}元（其中 微信：${res.data.wxPay}元 支付宝：${res.data.aliPay}元 园区支付：${res.data.rangePay}元 ），总支出：${res.data.totalPay}元`;
          this.totalData = {
            totalInconme: res.data.totalInconme,
            wxPay: res.data.wxPay,
            aliPay: res.data.aliPay,
            rangePay: res.data.rangePay,
            totalPay: res.data.totalPay,
            totalCount:res.data.count
          };
          for (let prop in res.data) {
            this[prop] = res.data[prop];
          }
        })
        .catch(error => {
          if (401 === error.response.status) {
            this.count = 0;
            this.data = [];
          }
        });
    },
    cell() {
      return { textAlign: "center" };
    },
    channelFormat(row, column) {
      let str = "";
      switch (row[column.property]) {
        case 1:
          str = "园区钱包";
          break;
        case 2:
          str = "微信";
          break;
        case 3:
          str = "支付宝";
          break;
        case 4:
          str = "--";
          break;
      }
      return str;
    },
    toViewDetail (id) {
      refundDetail(id).then(res => {
        console.log(res);
        this.refundRecordData = res.data;
        this.refundRecord = true;
      }).catch(error => {
        console.log(error);
      })
    },
    // 复制退款单号
    copyOrderId () {
      var clipboard = new Clipboard('.font');  
      clipboard.on('success', e => {  
        this.$message({
          message: "已复制到剪切板"
        });
        console.log("复制成功");//这里你如果引入了elementui的提示就可以用，没有就注释即可
        // 释放内存  
        clipboard.destroy(); 
      })  
      clipboard.on('error', e => {  
        // 不支持复制  
        console.log('该浏览器不支持自动复制')  
        // 释放内存  
        clipboard.destroy()  
      })
    },
  }
};
</script>
<style scoped lang='scss'>
.findWrap {
  width: 100%;
  height: 120px;
  display: flex;
  // flex-direction: column;
  justify-content: flex-start;
  .com {
    flex: 1;
    margin-right: 20px;
  }
  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // .total{
    //   width: 70%;
    //   margin-right: 20px;
    //   text-align: start;
    // }
  }
  .dateWrap {
    .el-form--inline {
      .el-form-item__content {
        width: 700px;
      }
    }
  }
}
.bianhao {
  min-width: 600px;
}
.pageWrap {
  margin-top: 20px;
  margin-bottom: 20px;
  .el-pagination {
    text-align: center;
  }
}
.button1 {
  height: 35px;
  line-height: 10px;
  margin-right: 20px;
}
.zhong {
  padding-top: 9px;
}
.header {
  display: flex;
  justify-content: space-between;
}
.btn {
  width: 100%;
  text-align: end;
  margin: 0 20px 13.3px 0;
}
.refundBtn{
  cursor: pointer;
  color:#409EFF;
}
.record{
  height:auto;
  .total{
    width:100%;
    height:40px;
    display: flex;
    // padding-bottom:39px;
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .dataList{
    width:100%;
    height:auto;
    .userName{
      display: flex;
      font-size:12px;
      line-height:40px;
      .name{
        flex-basis: 35%;
      }
      .money{
        flex: 1;
      }
    }
    .refundMothod{
      display: flex;
      font-size:12px;
      line-height:40px;
      .mothod{
        flex-basis: 50%;
      }
      .proson{
        flex: 1;
      }
    }
    .refundDate{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundTime{
        flex-basis: 50%;
      }
      .arriveTime{
        flex: 1;
      }
    }
    .orderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 50%;
      }
    }
    .oldOrderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 100%;
        .font{
          cursor: pointer;
          color:#409EFF;
          margin-left:20px;
        }
      }
    }
    .refundNote{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundNoteName{
        flex-basis: 64px;
      }
      .refundNoteText{
        flex: 1;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding:0 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchant/detail.vue